// extracted by mini-css-extract-plugin
export default {"themeToggler":"ThemeToggler_themeToggler__xOfc9"};